import { render, staticRenderFns } from "./Roadshow.vue?vue&type=template&id=347e5d48&scoped=true&"
import script from "./Roadshow.vue?vue&type=script&lang=js&"
export * from "./Roadshow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347e5d48",
  null
  
)

export default component.exports